import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faChevronLeft, faCircleNotch, faCalculator, 
    faStar, faShieldAlt, faBolt,
    faInfoCircle, faHeart as faHeartSolid 
} from '@fortawesome/free-solid-svg-icons';
import { faStar as farStar, faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { API_BASE } from './apiConfig';

import OrderModal from './OrderModal';
 const goldColor = '#c5a059';
const ServiceDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
  const { t, i18n } = useTranslation();
    
    const user = JSON.parse(localStorage.getItem('liber_user'));
    const token = localStorage.getItem('token'); 
   

    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const [reviews, setReviews] = useState([]);
    const [newReview, setNewReview] = useState({ comment: '', rating: 5 });
    const [hoverRating, setHoverRating] = useState(0);
    const [isFavorite, setIsFavorite] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        
        const PUBLIC_HEADERS = { 
            'ngrok-skip-browser-warning': 'true', 
            'Accept': 'application/json' 
        };

        const AUTH_HEADERS = {
            ...PUBLIC_HEADERS,
            'Authorization': `Bearer ${token}`
        };
        
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${API_BASE}/api/categories`, { headers: PUBLIC_HEADERS });
                const cats = await res.json();
               // Հիմա համեմատում ենք բազայի slug-ը հղման id-ի (որը արդեն բառ է լինելու) հետ
const current = cats.find(c => c.slug === id || String(c.id) === String(id));
                setCategory(current);

                if (current) {
                    const revRes = await fetch(`${API_BASE}/api/reviews/subservice/${current.id}`, { headers: PUBLIC_HEADERS });
                    if (revRes.ok) {
                        const revData = await revRes.json();
                        setReviews(Array.isArray(revData) ? revData : []);
                    }

                    if (user && user.id && token) {
                        const favRes = await fetch(`${API_BASE}/api/favorites/${user.id}`, { headers: AUTH_HEADERS });
                        if (favRes.ok) {
                            const favIds = await favRes.json();
                            if (Array.isArray(favIds) && favIds.includes(current.id)) setIsFavorite(true);
                        }
                    }

                 // Ուղղված տարբերակ
fetch(`${API_BASE}/api/stats/view-category/${current.id}`, { 
    method: 'POST', 
    headers: PUBLIC_HEADERS 
}).catch((err) => console.error("Դիտումը չգրանցվեց:", err));
                }
            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id, token]);

    const toggleFavorite = async () => {
        if (!user || !token) return navigate('/user-login');
        try {
            const res = await fetch(`${API_BASE}/api/favorites/toggle`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json', 
                    'ngrok-skip-browser-warning': 'true',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ user_id: user.id, subservice_id: category.id })
            });
            const result = await res.json();
            if (result.success) setIsFavorite(result.status === 'added');
        } catch (err) { console.error(err); }
    };

    const handleReviewSubmit = async (e) => {
        e.preventDefault();
        if (!user || !token) return alert(t('alert_login_to_review'));
        if (!newReview.comment.trim()) return alert(t('alert_write_text'));
        
        const reviewToSend = {
            subservice_id: category.id,
            service_id: 0,
            name: user.full_name || user.username,
            text: newReview.comment,
            stars: newReview.rating
        };

        try {
            const res = await fetch(`${API_BASE}/api/reviews`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json', 
                    'ngrok-skip-browser-warning': 'true',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(reviewToSend)
            });
            if (res.ok) {
                const addedReview = await res.json();
                setReviews([addedReview, ...reviews]);
                setNewReview({ comment: '', rating: 5 });
                alert(t('review_sent_success'));
            }
        } catch (err) { alert(t('error_generic')); }
    };

    const averageRating = useMemo(() => {
        if (reviews.length === 0) return 0;
        const sum = reviews.reduce((acc, curr) => acc + (Number(curr.stars) || 0), 0);
        return (sum / reviews.length).toFixed(1);
    }, [reviews]);

    const goToCalculator = () => {
        navigate(`/calculators?service=${encodeURIComponent(category.name)}`);
    };

    const renderStars = (rating, interactive = false) => {
        return [...Array(5)].map((_, i) => {
            const starValue = i + 1;
            const isFull = interactive ? (hoverRating || newReview.rating) >= starValue : rating >= starValue;
            return (
                <FontAwesomeIcon
                    key={i} icon={isFull ? faStar : farStar}
                    onClick={() => interactive && setNewReview({ ...newReview, rating: starValue })}
                    onMouseEnter={() => interactive && setHoverRating(starValue)}
                    onMouseLeave={() => interactive && setHoverRating(0)}
                    style={{ color: isFull ? goldColor : '#ddd', cursor: interactive ? 'pointer' : 'default', fontSize: interactive ? '22px' : '16px', marginRight: '4px' }}
                />
            );
        });
    };

    if (loading) return (
        <div style={s.loader}><FontAwesomeIcon icon={faCircleNotch} spin size="3x" color={goldColor} /></div>
    );

    if (!category) return <div style={s.error}>{t('service_not_found')}</div>;

    return (
        <div style={s.page}>
<Helmet defer={false}>
    <html lang={i18n.language || 'hy'} />
    <title>
        {category?.slug === 'moving' ? "Բեռնափոխադրում Երևանում 24/7 | Գազել Տաքսի | Liber.am" :
         category?.slug === 'waste' ? "Շինաղբի հեռացում և տեղափոխում (ԶԻԼ, Կամազ) | Liber Group" :
         `${category?.name} Երևանում | Մատչելի Գին | LIBER`}
    </title>

    <meta name="description" content={
        category?.seo_text 
        ? category.seo_text.substring(0, 160) 
        : `${category?.name} Երևանում և Հայաստանում: Պրոֆեսիոնալ թիմ, արագ մոտեցում և երաշխավորված որակ: Պատվիրեք օնլայն:`
    } />

    {/* Canonical-ը պետք է լինի շատ հստակ */}
    <link rel="canonical" href={`https://liber.am/service/${category?.slug}`} />
    
    {/* Խուսափիր keywords meta tag-ից, Google-ը դա չի նայում 2009-ից: Փոխարենը լավացրու OG թեգերը */}
    <meta property="og:title" content={`${category?.name} - Liber Group`} />
</Helmet>
            
            <div style={s.container}>
                <div style={s.headerRow}>
                    <button onClick={() => navigate('/')} style={s.backBtn}>
                        <FontAwesomeIcon icon={faChevronLeft} /> {t('btn_back')}
                    </button>
                    <div style={s.headerTitleBox}>
                        <h1 style={s.mainTitle}>{category.name}</h1>
                        <div style={{ ...s.goldLine, margin: '5px auto 0' }}></div>
                    </div>
                    <div style={{width: '60px'}}></div>
                </div>

                <div style={s.card}>
                    <div style={s.imgWrapper}>
<img 
  src={category.image ? `${API_BASE}${category.image}` : "/placeholder.png"} 
  alt={`${category.name} | ${category.slug.replace(/-/g, ' ')} | Liber Group`} 
  style={s.img}
  loading="lazy"
  decoding="async"
/>
<div style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
  <h2>{category.name} պատվիրելու առավելությունները</h2>
  <p>Մեր ընկերությունը առաջարկում է {category.name} լավագույն պայմաններով: 
     Մենք ապահովում ենք արագ մոտեցում, պրոֆեսիոնալ անձնակազմ և մատչելի գներ Երևանի բոլոր վարչական շրջաններում՝ 
     Կենտրոն, Աջափնյակ, Նոր Նորք, Էրեբունի:</p>
</div>
                        {/* <div onClick={toggleFavorite} style={s.heartBtn}>
                            <FontAwesomeIcon icon={isFavorite ? faHeartSolid : faHeartRegular} style={{ color: isFavorite ? '#ef4444' : goldColor, fontSize: '20px' }} />
                        </div> */}
                    </div>

                    <div style={s.content}>
                        <div style={s.tagRow}>
                            <span style={s.tag}>#liber</span>
                            <span style={s.tag}>#{category.name.replace(/\s+/g, '')}</span>
                            <span style={s.tag}>#professional</span>
                        </div>

                        <div style={s.ratingRow}>
                            <div style={{display: 'flex'}}>{renderStars(Math.round(averageRating))}</div>
                            <span style={s.ratingNum}>{averageRating}</span>
                            <span style={s.reviewCount}>({reviews.length} {t('reviews_count_label')})</span>
                        </div>
{/* Օրինական SEO Keyword Cloud - Սա Google-ը սիրում է */}
<div style={s.seoSection}>
    <h3 style={s.seoTitle}>{category?.name} - {t('service_tags_title', 'Հարակից ծառայություններ և որոնումներ')}</h3>
    <div style={s.keywordWrapper}>
        {[
            // Բեռնափոխադրում
            'բեռնափոխադրում երևան', 'bernapoxadrum erevanum', 'բեռնափոխադրումներ Հայաստան', 'էժան բեռնափոխադրում', 'bernapoxadrumner', 
            'bernatar taxi', 'gazel taxi erevan', 'գազել տաքսի', 'բեռնատար տաքսի', 'կահույքի տեղափոխում', 'kahuyqi texapoxum',
            // Աղբի հեռացում
            'աղբի հեռացում', 'shinaxbi heracum', 'շինաղբի տեղափոխում', 'aghbi heracum erevan', 'musor tapel', 'զիլ աղբի համար',
            // Բանվորական ուժ
            'բանվորական ուժ', 'banvorakan uj', 'gruzshik erevan', 'բեռնակիրներ', 'fureri datarkum', 'ֆուռերի դատարկում',
            // Քանդում
            'քանդման աշխատանքներ', 'pateri qandum', 'պատերի քանդում', 'սալիկների քանդում', 'demontaj erevan',
            // Մաքրում
            'մաքրման աշխատանքներ', 'maqrman ashxatanqner', 'կլինինգ', 'cleaning service Yerevan', 'բնակարանների մաքրում',
            // Տեխնիկա & Մայստեր
            'տեխնիկայի վարձակալություն', 'bobcat vardzuyt', 'տան մայստեր', 'santexnik erevan', 'elektrik erevan',
            // Լոկացիաներ
            'Երևան', 'Գյումրի', 'Վանաձոր', 'Հայաստան', 'Yerevan', 'Armenia', 'matcheli gner', '24/7 service'
        ].map((tag, index) => (
            <span key={index} style={s.seoTag}>{tag}</span>
        ))}
    </div>
</div>
                        <p style={s.desc}>{category.description}</p>
{category.seo_text && (
    <div style={s.seoDisplayBlock}>
        <h3 style={s.seoSubTitle}>{category.name} - Պրոֆեսիոնալ մոտեցում</h3>
        <p style={s.seoDescriptionText}>
            {category.seo_text}
        </p>
    </div>
)}
                        <div style={s.guideSection}>
                            <h3 style={{...s.guideTitle, color: goldColor}}><FontAwesomeIcon icon={faInfoCircle} /> {t('order_guide_title')}</h3>
                            <div style={s.stepsContainer}>
                                <div style={s.stepItem}>
                                    <div style={{...s.stepBadge, background: goldColor}}>1</div>
                                    <div style={s.stepText}>
                                        <strong>{t('step_1_title')}</strong>
                                        <span>{t('step_1_desc')}</span>
                                    </div>
                                </div>
                                <div style={s.stepItem}>
                                    <div style={{...s.stepBadge, background: goldColor}}>2</div>
                                    <div style={s.stepText}>
                                        <strong>{t('step_2_title')}</strong>
                                        <span>{t('step_2_desc')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={s.infoGrid}>
                            <div style={s.infoItem}>
                                <FontAwesomeIcon icon={faShieldAlt} color={goldColor} />
                                <span style={{fontSize: '13px', fontWeight: '600'}}>{t('info_guarantee')}</span>
                            </div>
                            <div style={s.infoItem}>
                                <FontAwesomeIcon icon={faBolt} color={goldColor} />
                                <span style={{fontSize: '13px', fontWeight: '600'}}>{t('info_fast_service')}</span>
                            </div>
                        </div>
                        
                        <div style={{...s.ctaBox, background: '#0f172a'}}>
                            <span style={{color: '#fff', fontSize: '14px'}}>{t('cta_ready_to_calc')}</span>
                            <button onClick={goToCalculator} style={{...s.mainOpenBtn, background: goldColor}}>
                                <FontAwesomeIcon icon={faCalculator} /> {t('btn_calculate_price')}
                            </button>
                        </div>
                    </div>
                </div>

                <div style={s.reviewsSection}>
                    <h2 style={{...s.sectionTitle, color: '#0f172a'}}>{t('customer_reviews_title')}</h2>
                    <div style={s.reviewForm}>
                        <div style={{marginBottom: '15px'}}>{renderStars(5, true)}</div>
                        <textarea 
                            style={s.textarea} 
                            placeholder={t('placeholder_write_review')}
                            value={newReview.comment}
                            onChange={(e) => setNewReview({...newReview, comment: e.target.value})}
                        />
                        <button style={{...s.submitReviewBtn, background: goldColor}} onClick={handleReviewSubmit}>{t('btn_send')}</button>
                    </div>

                    <div style={s.reviewsList}>
                        {reviews.length > 0 ? reviews.map((rev, idx) => (
                            <div key={idx} style={s.reviewItem}>
                                <div style={s.reviewHeader}>
                                    <strong>{rev.name}</strong>
                                    <div style={{display: 'flex'}}>{renderStars(rev.stars)}</div>
                                </div>
                                <p style={s.reviewText}>{rev.text}</p>
                            </div>
                        )) : <p style={{color: '#94a3b8', textAlign: 'center'}}>{t('no_reviews_yet')}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

const s = {
   
   seoSection: {
        // Այս հատվածը թաքցնում է ամբողջ բլոկը էջից
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0,0,0,0)',
        border: '0',
        whiteSpace: 'nowrap'
    },
    
    
    // Սրանք կարող ես թողնել նույնը կամ նույնիսկ ջնջել, 
    // քանի որ արդեն seoSection-ը սաղ թաքցրեց
    seoTitle: {
        fontSize: '13px',
        fontWeight: '700',
        color: '#475569'
    },
    seoDisplayBlock: {
        marginTop: '20px',
        padding: '20px',
        background: '#f8fafc',
        borderRadius: '16px',
        borderLeft: `4px solid ${goldColor}`,
        marginBottom: '25px'
    },
    seoSubTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#0f172a',
        marginBottom: '8px'
    },
    seoDescriptionText: {
        fontSize: '14px',
        color: '#64748b',
        lineHeight: '1.6',
        textAlign: 'justify'
    },
    
    keywordWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    
    seoTag: {
        fontSize: '11px',
        color: '#64748b'
    },
    
    // ... շարունակությունը


    page: { background: '#fafafa', minHeight: '100vh', padding: '120px 15px 120px', boxSizing: 'border-box' },
    container: { maxWidth: '750px', margin: '0 auto' },
    loader: { height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    headerRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' },
    mainTitle: { fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: 0 },
    goldLine: { width: '50px', height: '3px', background: '#c5a059', borderRadius: '2px' },
    backBtn: { border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: '700', color: '#64748b', fontSize: '15px' },
    card: { background: '#fff', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' },
    imgWrapper: { width: '100%', height: '320px', position: 'relative' },
    img: { width: '100%', height: '100%', objectFit: 'cover' },
    heartBtn: { position: 'absolute', top: '20px', right: '20px', background: '#fff', width: '42px', height: '42px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' },
    content: { padding: '30px' },
    tagRow: { display: 'flex', gap: '8px', marginBottom: '15px' },
    tag: { color: '#c5a059', fontSize: '12px', fontWeight: '700' },
    ratingRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' },
    ratingNum: { fontWeight: '800', color: '#0f172a', fontSize: '18px' },
    reviewCount: { color: '#94a3b8', fontSize: '14px' },
    desc: { fontSize: '15px', color: '#475569', lineHeight: '1.7', marginBottom: '25px' },
    guideSection: { margin: '25px 0', padding: '20px', background: '#fcfcfc', borderRadius: '15px', border: '1px solid #f1f1f1' },
    guideTitle: { fontSize: '16px', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' },
    stepsContainer: { display: 'flex', flexDirection: 'column', gap: '15px' },
    stepItem: { display: 'flex', gap: '12px', alignItems: 'center' },
    stepBadge: { color: '#fff', minWidth: '24px', height: '24px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold' },
    stepText: { display: 'flex', flexDirection: 'column' },
    infoGrid: { display: 'flex', gap: '20px', marginBottom: '30px', flexWrap: 'wrap' },
    infoItem: { display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 15px', background: '#f8fafc', borderRadius: '10px' },
    ctaBox: { padding: '18px 25px', borderRadius: '18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' },
    mainOpenBtn: { color: '#fff', border: 'none', padding: '12px 20px', borderRadius: '10px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' },
    reviewsSection: { marginTop: '50px' },
    sectionTitle: { fontSize: '22px', fontWeight: '800', marginBottom: '25px', textAlign: 'center' },
    reviewForm: { background: '#fff', padding: '25px', borderRadius: '20px', marginBottom: '30px', boxShadow: '0 4px 15px rgba(0,0,0,0.02)' },
    textarea: { width: '100%', height: '90px', borderRadius: '12px', border: '1px solid #eee', padding: '15px', fontSize: '14px', marginBottom: '15px', outline: 'none', resize: 'none', boxSizing: 'border-box' },
    submitReviewBtn: { color: '#fff', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: '700', cursor: 'pointer' },
    reviewItem: { background: '#fff', padding: '20px', borderRadius: '15px', border: '1px solid #f1f1f1', marginBottom: '15px' },
    reviewHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
    reviewText: { fontSize: '14px', color: '#64748b' }
};

export default ServiceDetail;